var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuEsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_11756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5262 10.4738C11.175 6.55407 14.31 2.63532 20.9728 3.0272C21.3647 9.69001 17.4459 12.825 13.5262 10.4738Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18751 10.6875C10.8975 7.83657 8.61751 4.98657 3.77157 5.27157C3.4847 10.1156 6.3347 12.3956 9.18751 10.6875Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.25H18.75",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.25L15.8803 20.4131C15.8432 20.5796 15.7504 20.7285 15.6173 20.8352C15.4842 20.9419 15.3187 21 15.1481 21H8.85187C8.68128 21 8.51577 20.9419 8.38266 20.8352C8.24955 20.7285 8.15679 20.5796 8.11969 20.4131L6.75 14.25",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5262 10.4738L9.75 14.25",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18561 10.6856L11.25 12.75",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_11756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--sidebar-text-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuEsg);
export default __webpack_public_path__ + "static/media/ic-menu-esg.9530fb96442e9cbb94f3c5e43eea8f56.svg";
export { ForwardRef as ReactComponent };